<script setup lang="ts">
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { dialogPt } from "../style.ts";

defineProps({
  visible: { type: Boolean, required: true },
});

const emit = defineEmits(["update:visible", "confirm", "cancel"]);
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    modal
    :pt="dialogPt"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-orange-100">
          <span class="material-icons-outlined text-2xl text-orange-500">warning_amber</span>
        </div>
        <h2 class="text-xl font-bold text-blue-900">Turn off payment processing?</h2>
      </div>
    </template>

    <p class="m-0 text-gray-600">
      Orders and applications for this brand will still be recorded, but
      <strong class="text-blue-900">no transactions will be processed through Stripe or sent to NetSuite</strong>.
      You can turn processing back on at any time.
    </p>

    <div class="mt-4 flex justify-end gap-2 border-t border-gray-200 pt-4">
      <Button
        label="Cancel"
        class="!border !border-gray-300 !bg-white !text-blue-900"
        @click="emit('cancel')"
      />
      <Button label="Turn off processing" severity="warning" @click="emit('confirm')" />
    </div>
  </Dialog>
</template>
